import { useId } from 'react';
import { tv } from 'tailwind-variants';
import Script from 'next/script';

import { useProductSheet } from 'context/product-sheet';
import { isBlank } from 'utils/StringUtils';
import { getBreadcrumbLdList } from 'components/ld-json/breadcrubms';

const brc = tv(
  {
    slots: {
      list: 'mb-0 flex flex-wrap items-center',
      item: 'flex items-center uppercase',
      link: '',
    },
    variants: {
      variant: {
        new: {
          item: 'text-sm',
          link: 'hover:underline data-[last]:hover:no-underline',
        },
        old: {
          list: 'gap-1.5',
          item: 'bg-[var(--color-grey-light)] px-4 py-1.5',
          link: 'text-[var(--color-black)]/45 text-xxs data-[last]:text-[var(--color-black)] hover:text-[var(--color-black)] hover:underline data-[last]:hover:no-underline',
        },
      },
    },
  },
  {
    // twMerge elimina clases añadidas en el extend de tailwind.
    twMerge: false,
  },
);

export function ProductBreadcrumbs({ withLd = true, className, variant = 'old', withCurrent = true }) {
  const brandId = useId();
  const {
    productSheet: { breadcrumbs, brand, baseUrl },
  } = useProductSheet();

  const { list, item, link } = brc({ variant });

  const breadcrumbList = breadcrumbs.filter((crumb) => !isBlank(crumb.name)) ?? [];

  if (withCurrent && !isBlank(brand) && !isBlank(baseUrl)) {
    breadcrumbList.push({ id: brandId, name: brand, href: baseUrl });
  }

  return (
    <div className={className}>
      {withLd ?
        <Script
          id="breadcrumbList"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getBreadcrumbLdList({ breadcrumbs: breadcrumbList })),
          }}
        />
      : null}
      <ol className={list()}>
        {breadcrumbList.map((crumb, index, array) => {
          const isLast = index === array.length - 1;
          return (
            <li key={`product-crumb-${crumb.id}`} className={item()}>
              {isLast && withCurrent && crumb.brandId === brandId ?
                <span data-last={isLast ? true : undefined} className={link()}>
                  {crumb.name}
                </span>
              : <>
                  <a data-last={isLast ? true : undefined} className={link()} href={crumb.url}>
                    {crumb.name}
                  </a>
                  {variant === 'new' && !isLast ?
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
                      <path fill="currentColor" d="m9.313 7.646.354-.353.707.707-.354.354-.707-.708Zm.707.708-3.333 3.333-.707-.707 3.333-3.334.707.708Z" />
                      <path fill="currentColor" d="m9.313 8.354.354.353.707-.707-.354-.354-.707.708ZM5.98 5.02l3.333 3.334.707-.708-3.333-3.333-.707.707Z" />
                    </svg>
                  : null}
                </>
              }
            </li>
          );
        })}
      </ol>
    </div>
  );
}

// ProductBreadcrumbs.propTypes = {
//   crumbs: arrayOf(
//     shape({
//       title: string,
//       href: string,
//     }),
//   ),
//   color: string,
// };
